import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { AppConfigService, httpOptions, Log } from '@core/services/config/app-config.service';

@Injectable({
    providedIn: 'root'
})
export class SidebarService {

    private isActiveSignal = signal(false);
    readonly isActive = this.isActiveSignal.asReadonly();

    constructor(
        private http: HttpClient,
        private appConfig: AppConfigService
    ) {

    }

    close() {
        // Implementa la logica per chiudere la sidebar
        this.isActiveSignal.set(true);
        this.isActiveSignal.set(false);
    }

    getIndex() {
        return this.http.get<any[]>(this.appConfig.apiUrl() + '/getIndex/' + this.appConfig.lang() + '/' + this.appConfig.domain(), httpOptions);
    }
}
